<template>
    <div class="row default-profile-progress">
        <div class="col-12 col-lg-8 left-side">
            <design-2021-profile-timeline-widget-component
                :cards-in="cardsIn"
                :categories-in="categoriesIn"
                :user-credentials-in="userCredentialsIn"
                :teacher-access="teacherAccess"
                :seasons-in="seasonsIn">
            </design-2021-profile-timeline-widget-component>

            <design-2021-survey-results-index-component :skill-trees-in="skillTreesIn">
            </design-2021-survey-results-index-component>
        </div>

        <div class="col-12 col-lg-4 right-side">
            <div class="apprentice-simple-card profile-progress-avatar-widget d-none d-lg-flex">
                <design-2021-user-profile-credentials-compact-component
                    :user-credentials-in="userCredentialsIn"
                    :teacher-access="teacherAccess">
                </design-2021-user-profile-credentials-compact-component>
            </div>

            <design-2021-personal-goal-widget-component
                :personal-goals-in="personalGoalsIn"
                :teacher-access="teacherAccess"
                :user-credentials-in="userCredentialsIn"
                :skill-trees-in="availableSchoolSkillTreesIn"
                :badges-in="badgesIn"
                :categories-in="categoriesIn"
                :seasons-in="seasonsIn">
            </design-2021-personal-goal-widget-component>

            <design-2021-module-widget-component
                v-if="hasModulesIn"
                :modules-in="modulesIn"
                :module-users-in="moduleUsersIn"
                :teacher-access="teacherAccess"
                :user-credentials-in="userCredentialsIn">
            </design-2021-module-widget-component>

            <design-2021-test-center-widget-component
                v-if="testResponsesIn.length"
                :test-responses-in="testResponsesIn">
            </design-2021-test-center-widget-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-default-profile-progress-component',
    props: {
        cardsIn: {
            type: Array,
            required: true,
        },
        categoriesIn: {
            type: Array,
            required: true,
        },
        userCredentialsIn: {
            type: Object,
            required: true,
        },
        modulesIn: {
            type: Array,
            required: true,
        },
        moduleUsersIn: {
            type: Array,
            required: true,
        },
        personalGoalsIn: {
            type: Array,
            required: true,
        },
        teacherAccess: {
            type: Boolean,
            required: false,
            default: false,
        },
        seasonsIn: {
            type: Array,
            required: true,
        },
        skillTreesIn: {
            type: Array,
            required: true,
        },
        availableSchoolSkillTreesIn: {
            type: Array,
            required: true,
        },
        hasModulesIn: {
            type: Boolean,
            required: true,
        },
        bannerIn: {
            type: Object,
            required: false,
        },
        badgesIn: {
            type: Array,
            required: true,
        },
        testResponsesIn: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss"></style>
